export const GITHUB_PROJECT_SLUG_ANNOTATION = 'github.com/project-slug';

export const PLATT_GH_SECURITY_INSIGHTS_ANNOTATION = 'platt.ap-com.app/use-gh-security-insights';
